import React from "react";
import cls from "./styles.module.scss";

export const EditorHotkeys = () => (
  <div className={cls.hotkeys}>
    <div>
      <b>Windows/Linux</b>
      <span>ЛКМ - группа</span>
      <span>ПКМ - гекс</span>
      <span>Alt + ЛКМ - зона</span>
      <span>Ctrl + ЛКМ/ПКМ - мультивыбор</span>
      <span>Z + ЛКМ/ПКМ - снять</span>
      <span>Режим лассо - зажмите ЛКМ и обведите гексы</span>
    </div>
    <div>
      <b>Mac</b>
      <span>ЛКМ - группа</span>
      <span>ПКМ - гекс</span>
      <span>Option + ЛКМ - зона</span>
      <span>Cmd + ЛКМ/ПКМ - мультивыбор</span>
      <span>Z + ЛКМ/ПКМ - снять</span>
      <span>Режим лассо - зажмите ЛКМ и обведите гексы</span>
    </div>
  </div>
);
